export const setIfExists = <T>(value: T): { set: T } | undefined =>
  value !== undefined ? { set: value } : undefined;
